import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'polaris-coreweb/exports';
import { helmetScripts } from 'Helpers';

import { withPolaris } from '@autovia-uk/polaris-components/components/protons/Polaris';

import { getComponentBlocks } from './getComponentBlocks';

const setWindowVariables = (embedTypes) => {
  embedTypes.forEach((type) => {
    if (type === 'Facebook' && window.FB) {
      window.FB.XFBML.parse();
    } else if (type === 'Twitter' && window.twttr) {
      window.twttr.widgets.load();
    }
  });
};

const Body = (props) => {
  const {
    context: { platform },
  } = props;
  const isAmp = platform === 'amp';
  const embedTypes = new Set();
  const blocks = getComponentBlocks(props, embedTypes, isAmp);

  useLayoutEffect(() => {
    if (embedTypes.size && typeof window !== 'undefined') {
      setWindowVariables(embedTypes);
    }
  });

  return (
    <>
      <Helmet>
        { !isAmp && helmetScripts(embedTypes) }
      </Helmet>
      {blocks}
    </>
  );
};

Body.propTypes = {
  context: PropTypes.shape(),
};

Body.defaultProps = {
  context: {},
};

export default withPolaris(Body);
